import { useEffect, useRef, useState } from "react";
import PrivateApi from "../../services/PrivateApiService";
import { Button, Col, Container, FormControl, Row } from "react-bootstrap";
import CustomerAnlageCard from "../../components/anlage/CustomerAnlageCard";
import { useQuery, useQueryClient } from "react-query";
import { useAuthState } from "../../context/AuthContext";
import { FaPlusCircle } from "react-icons/fa";
import QuickAccessCard from "../../components/shared/QuickAccessCard";
import { SlEnergy } from "react-icons/sl";
import { TbFlame } from "react-icons/tb";
import { MdOutlineSolarPower } from "react-icons/md";
import EnergoTab from "../../components/shared/EnergoTab";
import { BsDeviceSsdFill } from "react-icons/bs";
import { FaArrowUp } from "react-icons/fa6";
import ChangeAnlageModal from "../../components/anlage/ChangeAnlageModal";
import RegisterExistingAnlageModal from "../../components/anlage/RegistarExistingAnlageModal";
import SplashPage from "../SplashPage";
import DetailedAnlageActionCard from "../../components/anlage/DetailedAnlageActionCard";
import AreYouSureModal from "../../components/shared/AreYouSureModal";

/*
* old register Anlage link when no Anlage exists
* <h5>
*   Klicken Sie <a href="/dashboard/anlagen/anmelden/">hir <BsQrCode /> um Ihre Anlage mit QR zum Anmelden</a>
* </h5>
*/
const AnlagenPage = () => {

    // initial
    const API = new PrivateApi(); // API 
    const { user } = useAuthState(); // logged user
    const queryClient = useQueryClient();
    const [scrollBtnVisible, setScrollBtnVisible] = useState(false);
    const activeRef = useRef(null);
    const unActiveRef = useRef(null);
    const [changeModal, setChangeModal] = useState(false);
    const [unRegisterModal, setUnregisterModal] = useState(false);

    // data vars
    const [elvs, setElvs] = useState([])
    const [anlagen, setAnlagen] = useState([]);
    const [filteredAnlagen, setFilteredAnlagen] = useState([])
    const [tickets, setTickets] = useState([]);
    const [anlageForChange, setAnlageForChange] = useState(0);
    const [elvForChange, setElvForChange] = useState(null);
    const [lastSwitch, setLastSwitch] = useState("");

    const [sureModal, setSureModal] = useState(false);
    const [sureLoading, setSureLoading] = useState(false);
    const [ticketForClosingId, setTicketForClosingId] = useState(0)


    // fields and buttons]
    const [quickAccessData, setQuickAccessData] = useState({
        all: {id: 1, count: 0},
        strom: {id: 2, count: 0},
        gas: {id: 3, count: 0},
        einspeisung: {id: 4, count: 0},
    });
    const [selectedQuickAccess, setSelectedQuickAccess] = useState(1);
    const [tabData, setTabData] = useState([{id: 1, name:"Aktuell", count: 1, selected: false}, {id: 2, name:"Historisch", count: 0, selected: false}]);
    const [selectedTab, setSelectedTab] = useState(1);
    const [searchField, setSearchField] = useState("");

    //* collect data
    const { data, error, isLoading } = useQuery("CLIENT_GET_ANLAGEN", API.client_anlagen, 
        {
            staleTime: Infinity,
            onSuccess: (resp) => {
                // fill data vars
                setElvs(resp.data.elvs);
                setAnlagen(resp.data.anlagen.sort(anlagenSort));
                setTickets(resp.data.tickets);
                setFilteredAnlagen(resp.data.anlagen.sort(anlagenSort));

                // count data
                var stromCount = resp.data.anlagen.filter(a => a.x_studio_field_3eKe0 === "Strom" && a.x_studio_field_Xhbek[0] === user.id).length;
                var gasCount = resp.data.anlagen.filter(a => a.x_studio_field_3eKe0 === "Gas" && a.x_studio_field_Xhbek[0] === user.id).length;
                var pvCount = resp.data.anlagen.filter(a => a.x_studio_field_3eKe0 === "Strom-Einspeisung" && a.x_studio_field_Xhbek[0] === user.id).length;
                var activeCount = resp.data.anlagen.filter(a => a.x_studio_field_Xhbek.length > 0 && a.x_studio_field_Xhbek[0] === user.id).length;
                var unactiveCount = resp.data.anlagen.filter(a => a.x_studio_field_Xhbek.length === 0 || a.x_studio_field_Xhbek[0] !== user.id).length;

                // set data
                setQuickAccessData((prev) => ({ ...prev, ['all']: {...prev["all"], count: activeCount}}));
                setQuickAccessData((prev) => ({ ...prev, ['strom']: {...prev["strom"], count: stromCount}}));
                setQuickAccessData((prev) => ({ ...prev, ['gas']: {...prev["gas"], count: gasCount}}));
                setQuickAccessData((prev) => ({ ...prev, ['einspeisung']: {...prev["einspeisung"], count: pvCount}}));
                setTabData(prev => prev.map(tab => tab.name === "Aktuell"? {...tab, count: activeCount}: tab));
                setTabData(prev => prev.map(tab => tab.name === "Historisch"? {...tab, count: unactiveCount}: tab));
                if (activeCount > 0) setTabData(prev => prev.map(tab => tab.name === "Aktuell"? {...tab, selected: true}: tab));
            }
        }
    );

    //* effects
    // on load
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.target.innerHTML === "Aktuelle Anlagen") {
                    setSelectedTab(1);
                }
                if (entry.target.innerHTML === "Historische Anlagen") {
                    setSelectedTab(2);
                }
            },
            {
                root: null,
                rootMargin: '0px',
                threshold: 0.5,
            }
        );
        if (activeRef.current) {
            observer.observe(activeRef.current);
        }
        if (unActiveRef.current) {
            observer.observe(unActiveRef.current);
        }

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        }
    }, []);


    useEffect(() => {
        var stromCount = 0;
        var gasCount = 0;
        var pvCount = 0;
        var allCount = 0;

        if (tabData[0].selected) {
            stromCount += filteredAnlagen.filter(a => a.x_studio_field_3eKe0 === "Strom" && a.x_studio_field_Xhbek[0] === user.id).length;
            gasCount += filteredAnlagen.filter(a => a.x_studio_field_3eKe0 === "Gas" && a.x_studio_field_Xhbek[0] === user.id).length;
            pvCount += filteredAnlagen.filter(a => a.x_studio_field_3eKe0 === "Strom-Einspeisung" && a.x_studio_field_Xhbek[0] === user.id).length;
            allCount += filteredAnlagen.filter(a => a.x_studio_field_Xhbek.length > 0 && a.x_studio_field_Xhbek[0] === user.id).length;
        }
        if (tabData[1].selected) {
            stromCount += filteredAnlagen.filter(a => a.x_studio_field_3eKe0 === "Strom" && a.x_studio_field_Xhbek[0] !== user.id).length;
            gasCount += filteredAnlagen.filter(a => a.x_studio_field_3eKe0 === "Gas" && a.x_studio_field_Xhbek[0] !== user.id).length;
            pvCount += filteredAnlagen.filter(a => a.x_studio_field_3eKe0 === "Strom-Einspeisung" && a.x_studio_field_Xhbek[0] !== user.id).length;
            allCount += filteredAnlagen.filter(a => a.x_studio_field_Xhbek.length === 0 || a.x_studio_field_Xhbek[0] !== user.id).length;
        }
        setQuickAccessData((prev) => ({ ...prev, ['all']: {...prev["all"], count: allCount}}));
        setQuickAccessData((prev) => ({ ...prev, ['strom']: {...prev["strom"], count: stromCount}}));
        setQuickAccessData((prev) => ({ ...prev, ['gas']: {...prev["gas"], count: gasCount}}));
        setQuickAccessData((prev) => ({ ...prev, ['einspeisung']: {...prev["einspeisung"], count: pvCount}}));
        
    }, [tabData])


    useEffect(() => {
        filtersHandler();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedQuickAccess, searchField]);


    //* handlers

    // scroll to top
    const scrollTopHandler = () => {
        var headerDiv = document.getElementById('headerDesc');
        if (headerDiv) {
            headerDiv.scrollIntoView({ behavior: "smooth", block: "center"});
        }
        setSelectedTab(1)
    }

    // change aktuell/historisch view
    const changeTabView = (id) => {
        setSelectedTab(id);
        const element = document.getElementById(`section-${id}`);
        if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "center"});
        }
    }

    // filters handler
    const filtersHandler = () => {
        var tempFiltered = anlagen;
        if (selectedQuickAccess === 1) tempFiltered = anlagen;
        if (selectedQuickAccess === 2) tempFiltered = tempFiltered.filter(a => a.x_studio_field_3eKe0 === "Strom");
        if (selectedQuickAccess === 3) tempFiltered = tempFiltered.filter(a => a.x_studio_field_3eKe0 === "Gas");
        if (selectedQuickAccess === 4) tempFiltered = tempFiltered.filter(a => a.x_studio_field_3eKe0 === "Strom-Einspeisung");

        if (searchField !== "") {
            tempFiltered = tempFiltered.filter(a => 
                a.x_studio_field_mWMGR.toLowerCase().includes(searchField.toLowerCase()) ||
               // a.x_zaehlernummer_01.toLowerCase().includes(searchField.toLowerCase()) ||
               // a.x_zaehlernummer_02.toLowerCase().includes(searchField.toLowerCase()) ||
                a.x_adresse_kompakt.toLowerCase().includes(searchField.toLowerCase())
            )
        }

        setFilteredAnlagen(tempFiltered);
    }

    // quickaccess card clicked
    const quickaccessClick = (id) => {
        setSelectedQuickAccess(id);
    }

    // handle scroll
    const handleScroll = () => {
        const scrollTop = window.scrollY;

        if (scrollTop > 200) {
            setScrollBtnVisible(false);
        } else {
            setScrollBtnVisible(true);
        }
    };

    // Custom sorting function
    const anlagenSort = (a, b) => {
        // Check if x_studio_field_6T9W2 is "False" for both objects
        if (a.x_studio_field_6T9W2 === 'False' && b.x_studio_field_6T9W2 === 'False') {
            return 0; // Maintain current order
        }

        // Check if x_studio_field_6T9W2 is "False" for only one object
        if (a.x_studio_field_6T9W2 === 'False') {
            return 1; // Move "False" values to end
        }

        if (b.x_studio_field_6T9W2 === 'False') {
            return -1; // Move "False" values to end
        }

        // Custom comparison for "2a" before numeric values
        const sanitizedA = a.x_studio_field_6T9W2.replace(/[^0-9]/g, '');
        const sanitizedB = b.x_studio_field_6T9W2.replace(/[^0-9]/g, '');

        // Convert to numbers
        const numA = parseFloat(sanitizedA);
        const numB = parseFloat(sanitizedB);

        // If both are numeric, sort numerically
        if (!isNaN(numA) && !isNaN(numB)) {
            return numA - numB;
        }

        // If one is numeric and the other is not, numeric goes first
        if (!isNaN(numA) && isNaN(numB)) {
            return -1;
        }

        if (isNaN(numA) && !isNaN(numB)) {
            return 1;
        }

        // If both are non-numeric, sort alphabetically
        return sanitizedA.localeCompare(sanitizedB);
    };

    const createNewAnlageCard = (ticket) => {;
        if (ticket.description.includes('<tbody>')) {
            var anlage_object = {};
            var table = ticket.description.split('<tbody>');

            table.forEach(tbl => {
                var rowsAnlage = tbl.split('<tr>').filter(Boolean);
                rowsAnlage.forEach((row) => {
                    anlage_object['x_studio_field_mWMGR'] = ticket.id;
                    const matches = row.match(/<td>(.*?)<\/td>/g);
                    if (matches && matches.length >= 2) {
                        const key = matches[0].replace(/<td>|<\/td>/g, '').trim();
                        const value = matches[1].replace(/<td>|<\/td>/g, '').trim();
    
                        if (key === "Straße") {
                            anlage_object['x_adresse_kompakt'] = `${value} `;
                        }
                        if (key === 'Hausnummer') {
                            anlage_object['x_adresse_kompakt'] += `${value}`;
                        }
                        if (key === 'Stiege/Stockwerk') {
                            if (value !== '' && value !== "False") {
                                anlage_object['x_adresse_kompakt'] += `/${value}`;
                            }
                        }
                        if (key === "Top") {
                            anlage_object['x_adresse_kompakt'] += `/${value}`;
                        }
                        if (key === "Energieform") {
                            anlage_object['x_studio_field_3eKe0'] = value;
                        } 
                        if (key === "Anlagenverwendung") {
                            anlage_object['x_anlagenverwendung'] = value;
                        }
                        if (key === "Spezifische Anlagenverwendung") {
                            anlage_object['x_anlagenverwendung_detail'] = value? value : "";
                        }
                        if (key === "Zählernummer") {
                            anlage_object['x_zaehlernummer_01'] = value;
                            anlage_object['x_zaehlpunktnummer_01'] = '?';
                            anlage_object['x_lastprofil_01'] = '?';
                        }
                        if (key === 'Zählpunktnummer 1') {
                            anlage_object['x_zaehlpunktnummer_01'] = value;
                        }
                        if (key === 'Lastprofil') {
                            anlage_object['x_lastprofil_01'] = value;
                        }
                        if (key === 'Smartmeter') {
                            if (value === "Ja") anlage_object['x_is_smartmeter_01'] = true;
                            else  anlage_object['x_is_smartmeter_01'] = false;
                        }
    
                        if (key === "Zweite Zählernummer") {
                            anlage_object['x_zaehlernummer_02'] = value;
                            anlage_object['x_zaehlpunktnummer_02'] = '?';
                            anlage_object['x_lastprofil_02'] = '?';
                        }
                        if (key === 'Zählpunktnummer 2') {
                            anlage_object['x_zaehlpunktnummer_02'] = value;
                        }
                        if (key === 'Lastprofil 2') {
                            anlage_object['x_lastprofil_02'] = value;
                        }
                        if (key === 'Smartmeter 2') {
                            if (value === "Ja") anlage_object['x_is_smartmeter_02'] = true;
                            else  anlage_object['x_is_smartmeter_02'] = false;
                        }
    
                        anlage_object[key] = value;
                        //anlage_object['x_studio_field_mWMGR'] = "new";
                    }
                    if (anlage_object.x_zaehlernummer_02 === undefined) anlage_object.x_zaehlernummer_02 = "";
                })
            })

            if (table[3] !== undefined) {
                const rowsRegister = table[3].split('<tr>').filter(Boolean);
                rowsRegister.forEach((row) => {
                    const matches = row.match(/<td>(.*?)<\/td>/g);
                    if (matches && matches.length >= 2) {
                        const key = matches[0].replace(/<td>|<\/td>/g, '').trim();
                        const value = matches[1].replace(/<td>|<\/td>/g, '').trim();

                        anlage_object[key] = value;
                    }
                })
            }

            return (
                <DetailedAnlageActionCard
                    key={`ticket-${anlage_object.x_zaehlernummer_01}`}
                    anlage={anlage_object}
                    ticket={[ticket]}
                    switchHandler={"none"}
                    transparent
                />
            )
        }
    }

    const changeModalHandler = (anlage) => {
        setAnlageForChange(anlage);
        setChangeModal(true);
    }

    const unregisterAnlageHandler = (anlage) => {
        setUnregisterModal(true);
        setAnlageForChange(anlage);
        setElvForChange(elvs.filter(e => anlage.x_elv_ids.includes(e.id)));
        setLastSwitch(`switch-${anlage.id}`);
    }

    const cancelActionHandler = (ticket_id) => {
        setSureModal(true);
        setTicketForClosingId(ticket_id)
    }

    const sureHandler = () => {
        if (ticketForClosingId !== 0) {
            setSureLoading(true);
            var data = {ticket_id: ticketForClosingId, user: user};
            API.post_Ticket_close(data)
                .then(() => {
                    queryClient.invalidateQueries("CLIENT_GET_ANLAGEN");
                    setSureModal(false);
                })
                .finally(() => setSureLoading(false));
        }
    }

    // if data is loading
    if (isLoading) return <SplashPage />
    
    // if error occurred by collecting data
    if (error) return <Container><p className="text-danger">Fehler aufgetreten. Versuchen Sie es später nochmal.</p></Container>
    

    // GUI
    return (
        <>
            <Container className="text-start">
                <Row className="align-items-center" id="headerDesc">
                    <Col xs="12" md="12" xl="8">
                        <h4>Ihre Anlagen</h4>
                        <p className="text-secondary">Alle Ihre Anlagen bei ENERGO</p>
                    </Col>
                    <Col xs="12" md="4" xl="4" className="text-end">
                        <a
                            href="/dashboard/anlagen/anmelden/"
                            className="btn btn-energo rounded-pill"
                        >
                            <FaPlusCircle style={{ marginRight: 10, marginTop: -2}} size={30} />
                            <span>Neue Anlage hinzufügen</span>
                        </a>
                    </Col>
                </Row>

                <Row className="mt-3">
                    <Col xl="3">
                        <QuickAccessCard
                            id={quickAccessData.all.id}
                            key={quickAccessData.all.id}
                            schema="primary"
                            icon={<BsDeviceSsdFill size={40} />}
                            count={quickAccessData.all.count}
                            title="Alle"
                            desc="Zeige alle Anlagen"
                            isSelected={quickAccessData.all.id === selectedQuickAccess}
                            handler={quickaccessClick}
                        />
                    </Col>
                    <Col xl="3">
                        <QuickAccessCard
                            id={quickAccessData.strom.id}
                            key={quickAccessData.strom.id}
                            schema="energo"
                            icon={<SlEnergy size={40} />}
                            count={quickAccessData.strom.count}
                            title="Strom"
                            desc="Zeige alle Stromanlagen"
                            isSelected={quickAccessData.strom.id === selectedQuickAccess}
                            handler={quickaccessClick}
                        />
                    </Col>
                    <Col xl="3">
                        <QuickAccessCard
                            id={quickAccessData.gas.id}
                            key={quickAccessData.gas.id}
                            schema="info"
                            icon={<TbFlame size={40} />}
                            count={quickAccessData.gas.count}
                            title="Gas"
                            desc="Zeige alle Gasanlagen"
                            isSelected={quickAccessData.gas.id === selectedQuickAccess}
                            handler={quickaccessClick}
                        />
                    </Col>
                    <Col xl="3">
                        <QuickAccessCard
                            id={quickAccessData.einspeisung.id}
                            key={quickAccessData.einspeisung.id}
                            schema="warning"
                            icon={<MdOutlineSolarPower size={40} />}
                            count={quickAccessData.einspeisung.count}
                            title="Einspeisung"
                            desc="Zeige alle Einspeisungsanlagen"
                            isSelected={quickAccessData.einspeisung.id === selectedQuickAccess}
                            handler={quickaccessClick}
                        />
                    </Col>
                </Row>

                <Row className="mt-5 mb-5">
                    <Col xl="4">
                        <EnergoTab data={tabData} setData={setTabData}/>
                    </Col>
                    <Col xs="12" md="4" xl="8" className="text-center">
                        <FormControl 
                            value={searchField}
                            onChange={e => setSearchField(e.target.value)}
                            size="lg" 
                            type="search" 
                            className="rounded-pill" 
                            placeholder="Suchen nach Anlagennummer, Adresse, Stadt, PLZ" 
                        />
                    </Col>
                </Row>

                {tickets.length > 0 && tickets.filter(t => t.ticket_type_id[0] === 17).length > 0?
                    <div style={{marginTop: 150}}>
                        <h4>Neu erfasste Anlagen</h4>
                        <hr />
                        {tickets.filter(ticket => ticket.ticket_type_id[0] === 17).map(t => 
                            createNewAnlageCard(t)
                        )}
                    </div>
                :null}
                {filteredAnlagen.length > 0 &&
                    <>
                    {filteredAnlagen.filter(fa => fa.x_studio_field_Xhbek.length > 0 && fa.x_studio_field_Xhbek[0] === user.id).length > 0?
                        <div style={{marginTop: 120}} id="section-1" key={"section-1"} hidden={tabData[0].selected === false}>
                            <h4 ref={activeRef} id="section-1">Aktuelle Anlagen</h4>
                            <hr />
                            {filteredAnlagen.filter(fa => fa.x_studio_field_Xhbek.length > 0 && fa.x_studio_field_Xhbek[0] === user.id).map(anlage => 
                                <div key={`cardcontainer-${anlage.id}`} className="mb-5">
                                    <h5>Adresse: {anlage.x_adresse_kompakt}</h5>
                                    <DetailedAnlageActionCard 
                                        owner={user.id}
                                        anlage={anlage}
                                        elvs={elvs}
                                        ticket={tickets && tickets.length > 0? tickets.filter(t => t.x_anlage_id[0] === anlage.id) : undefined}
                                        switchHandler={unregisterAnlageHandler}
                                        cancelHandler={cancelActionHandler}
                                        changeHandler={changeModalHandler}
                                    />
                                </div>
                            )}
                        </div>
                    :null}  
                    {filteredAnlagen.filter(fa => fa.x_studio_field_Xhbek.length === 0 || fa.x_studio_field_Xhbek[0] !== user.id).length > 0?
                        <div style={{marginTop: 120}} hidden={tabData[1].selected === false}>
                            <h4 ref={unActiveRef} id="section-2" key={"section-2"}>Historische Anlagen</h4>
                            <hr />
                            {filteredAnlagen.filter(fa => fa.x_studio_field_Xhbek.length === 0 || fa.x_studio_field_Xhbek[0] !== user.id).map(anlage => 
                                <div key={`cardcontainer-${anlage.id}`} className="mb-5">
                                    <h5 key={`address-${anlage.id}`}>Adresse: {anlage.x_adresse_kompakt}</h5>
                                    <DetailedAnlageActionCard
                                        owner={user.id}
                                        anlage={anlage}
                                        elvs={elvs}
                                        transparent
                                        history
                                    />
                                </div>
                            )}
                        </div>
                    :null}
                    </>
                }


                

                <Row className="justify-content-center mt-5">
                </Row>
            </Container>
            {!scrollBtnVisible ?
                <Button
                    onClick={() => scrollTopHandler()}
                    className="shadow-lg btn-energo"
                    style={{
                        width: 60,
                        paddingTop: 10, paddingBottom: 10,
                        borderRadius: 15, position: "fixed",
                        bottom: "10%", right: "2%",
                    }}
                >
                    <FaArrowUp size={35} className="text-white" />
                </Button>
            :null}
            <ChangeAnlageModal anlage={anlageForChange} show={changeModal} setShow={setChangeModal} noContact />
            <RegisterExistingAnlageModal
                show={unRegisterModal}
                setShow={setUnregisterModal}
                anlage={anlageForChange}
                elv={elvForChange}
                lastSwitch={lastSwitch}
                noContact
            />
            
            <AreYouSureModal
                show={sureModal}
                setShow={setSureModal}
                title="Aktion abbrechen"
                message="Sind Sie sicher, dass Sie diese Aktion abbrechen wollen?"
                loading={sureLoading}
                yesHandler={sureHandler}
            />
        </>
    )
}

export default AnlagenPage;